import React from 'react';
import {connect} from 'react-redux';

import mapDispatch from '~/misc/mapDispatch';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';

import css from './index.css';

class VerifyAccount extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        {
          !this.props.user.emailVerified && this.props.dots.mainSwitch.data.email_switch.switch 
          ? <div className={css.wrap}>
            <p className={css.tit}>
              Your email has has not been verified.
              <span className={css.btn} onClick={() => this.verifyEmail()}>Click to Verify</span>
            </p>
          </div>
          :null
        }
        {
          !this.props.user.verified_phone && this.props.dots.mainSwitch.data.email_switch.switch 
          ? <div className={css.wrap}>
            <p className={css.tit}>
              You Phone Number has not been verified.
              <span className={css.btn} onClick={() => this.verifyPhone()}>Click to Verify</span>
            </p>
          </div>
          :null
        }
      </div>
      
    )
  }
  verifyEmail() {
    this.props.verifyEmail(this.props);
  }
  verifyPhone = () => {
    this.props.verifyPhone(this.props);
  }
}

export default connect(
  ({user, dots}) => ({user, dots}
), mapDispatch({
  verifyEmail: (props, data) => modalChange(
    modes.EMAIL_VALIDATE,
    {
      email: data.user.email,
      type: 'askPop',
      source: 'sign-up-pop',
    }
  ),
  verifyPhone: (props, data) => modalChange(
    modes.PHONE_VALIDATE,
    {
      email: data.user.email,
      from: props.from,
      type: 'askPop',
      source: 'sign-up-pop',
    }
  ),
  login: () => modalChange(modes.LOGIN, 'user-account'),
}))(VerifyAccount);



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/VerifyAccount/index.js